module.exports = __webpack_public_path__ + "img/iconWoDeGuanYuWoMen.aa608e41.svg";